// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
// eslint-disable-next-line no-restricted-imports
import {
  AccessLevel,
  MemberModel,
  MembershipModel,
} from 'app/gamma/src/types/models';

export const getMemberTypeFromMemberships = (
  state: State,
  memberships: MembershipModel[] = [],
  member: MemberModel,
  idOrganization?: string | null | undefined,
): AccessLevel => {
  const membership: MembershipModel | undefined = memberships.find(
    ({ idMember }) => idMember === member.id,
  );
  let memberType: AccessLevel;

  if (
    idOrganization &&
    member.idPremOrgsAdmin &&
    member.idPremOrgsAdmin.includes(idOrganization)
  ) {
    memberType = 'admin';
  } else if (!membership) {
    memberType = 'public';
  } else if (membership.unconfirmed) {
    memberType = 'unconfirmed';
  } else if (membership.deactivated) {
    memberType = 'deactivated';
  } else {
    memberType = membership.memberType;
  }

  if (memberType !== 'public' && member.memberType === 'ghost') {
    memberType = 'virtual';
  }

  return memberType;
};
